import { match as objectid } from "../../../src/params/objectid.ts";
import { match as savedview } from "../../../src/params/savedview.ts";

export const matchers = { objectid, savedview };